import { ChipProps } from '@mui/material';

export interface OrderStatusDescriptor {
  label: string;
  color: ChipProps['color'];
}

/**
 * Maps SAP document status / cancellation flags to a customer-facing German
 * label and a MUI chip colour. Shared by the orders list and detail views.
 */
export function resolveOrderStatus(
  documentStatus: string | null | undefined,
  cancelled?: string | null,
): OrderStatusDescriptor {
  if (cancelled === 'tYES' || cancelled === 'Y') {
    return { label: 'Storniert', color: 'default' };
  }

  switch (documentStatus) {
    case 'bost_Open':
    case 'O':
      return { label: 'Offen', color: 'info' };
    case 'bost_Close':
    case 'C':
      return { label: 'Erledigt', color: 'success' };
    case 'bost_Paid':
      return { label: 'Bezahlt', color: 'success' };
    case 'bost_Delivered':
      return { label: 'Geliefert', color: 'success' };
    default:
      return { label: documentStatus || 'Unbekannt', color: 'default' };
  }
}
